var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWordpress = function SvgWordpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wordpress_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.04 8.323q.105.763.107 1.645c0 2.813-.26 2.971-6.104 19.862C28.8 27.056 32 21.902 32 16c0-2.782-.71-5.398-1.96-7.677M16.282 17.4 11.48 31.348c3.24.954 6.674.857 9.834-.253a1.4 1.4 0 0 1-.114-.222zm10.52-2.208c0-1.977-.71-3.348-1.32-4.413-.81-1.318-1.572-2.433-1.572-3.752 0-1.47 1.117-2.84 2.688-2.84.07 0 .138.01.207.013A15.94 15.94 0 0 0 16 0C10.411 0 5.493 2.867 2.632 7.21c1.02.033 2.387.046 5.294-.181.863-.051.964 1.216.103 1.316 0 0-.867.103-1.832.154l5.827 17.331 3.5-10.502-2.492-6.83c-.86-.05-1.677-.153-1.677-.153-.862-.05-.761-1.369.101-1.318 3.307.255 5 .274 8.478 0 .863-.05.965 1.216.103 1.318 0 0-.869.103-1.832.153l5.782 17.2c2.283-7.63 2.815-8.906 2.815-10.506M0 16c0 6.333 3.68 11.806 9.018 14.4L1.386 9.488A15.9 15.9 0 0 0 0 16",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wordpress_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgWordpress;